import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import * as graphql from 'generated/graphql';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import { TalentReview as TalentReviewV1 } from 'packages/kakapo-ui-application/pages/talent-reviews/TalentReview';

import { ChevronLeftIcon } from '@treams/treams-icons';
import { Button, Container, Toolbar } from '@treams/treams-ui';

export default function TalentReview(props: { id: string }) {
	const { t } = useTranslation();

	const query = graphql.useTalentReviewQuery({ variables: { id: props.id } });

	return (
		<Container>
			{query.data ? (
				<Box py={4}>
					<Toolbar>
						<Button
							icon={<ChevronLeftIcon />}
							link="/talent-reviews"
							title={t('goals.show.toolbar.back')}
							type="secondary"
						/>
					</Toolbar>
					<TalentReviewV1 review={query.data.talentReview as graphql.TalentReview} />
				</Box>
			) : (
				<Spinner isLoading size="18px" />
			)}
		</Container>
	);
}
